const en = {
  nav: {
    services: "Services", how: "How It Works", area: "Service Area", request: "Request Help", menu: "Menu",
    home: "Home", privacy: "Privacy", terms: "Terms", skip: "Skip to main content", admin: "Owner login",
  },
  cta: {
    getHelp: "GET HELP NOW", callNow: "CALL NOW", textUs: "TEXT US", requestHelp: "Request Help",
    requestService: "REQUEST THIS SERVICE", phoneSoon: "Phone line coming soon — request help online",
    callShort: "Call Now",
  },
  hero: {
    eyebrow: "Houston, Texas · Towing & Roadside",
    title: "Stranded? We're On Our Way.",
    sub247: "24/7 Towing & Roadside Assistance in Houston, Texas.",
    sub: "Towing & Roadside Assistance in Houston, Texas.",
    note: "Send your location in under 2 minutes. We'll contact you to confirm the service, price and arrival time.",
    imageAlt: "Black flatbed rollback tow truck loading a car on a Houston highway shoulder at night",
  },
  sections: {
    servicesTitle: "Roadside Services",
    servicesSub: "Pick what you need. Your request form opens with that service already selected.",
    howTitle: "How it works",
    how: [
      ["Send your request", "Choose a service, share your location and vehicle details."],
      ["We contact you", "We call or text to confirm the job, details and price."],
      ["Dispatch confirmed", "Once you approve, we let you know when a driver is assigned."],
      ["Back on the road", "Your vehicle is serviced on the spot or towed where you need it."],
    ],
    areaTitle: "Service area",
    areaSub: "Our starting point is {area}. Not sure if we cover your location? Send a request and we'll confirm.",
    zips: "ZIP codes served",
    hours: "Hours",
    safetyTitle: "Safety first",
    safetyText: "If you are in danger or anyone is injured, call 911 first. Move to a safe place away from traffic if you can, and turn on your hazard lights.",
    pricingTitle: "Pricing",
    serviceCall: "Service call fee",
    perMile: "Per mile",
    from: "From",
    customQuote: "Final price is confirmed with you before any work begins.",
    ctaTitle: "Need help right now?",
    ctaSub: "Send your request online — it takes about two minutes.",
  },
  services: {
    flatbed: ["Flatbed Towing", "Rollback flatbed transport for cars, SUVs, AWD and low-clearance vehicles."],
    local_tow: ["Local Towing", "Towing to a shop, home or dealership within the Houston area."],
    long_distance: ["Long-Distance Towing", "Towing beyond the local area to the destination you choose."],
    accident: ["Accident Recovery", "Removal and towing of vehicles after a collision."],
    flat_tire: ["Flat Tire Change", "We swap your flat tire for your spare on the spot."],
    spare_tire: ["Spare Tire Installation", "Mounting your spare tire so you can drive to a tire shop."],
    jump_start: ["Jump Start / Dead Battery", "A jump start for a dead or weak battery."],
    lockout: ["Car Lockout / Keys Locked Inside", "Help getting into your vehicle when keys are locked inside."],
    fuel: ["Fuel Delivery", "Out of gas? We bring enough fuel to get you to a station."],
    winch: ["Winch-Out / Stuck Vehicle", "Pulling vehicles out of mud, ditches, sand or soft ground."],
    motorcycle: ["Motorcycle Towing", "Secure towing for motorcycles and scooters."],
    transport: ["Vehicle Transport", "Planned transport for non-running, purchased or project vehicles."],
    other: ["Other Roadside Assistance", "Something else? Describe the problem and we'll get back to you."],
  },
  wizard: {
    title: "Request roadside assistance",
    steps: ["Service", "Location", "Details & send"],
    stepOf: "Step {n} of 3",
    moreVehicle: "Add more vehicle details (optional)",
    moreContact: "Add email or contact instructions (optional)",
    finalTitle: "Your vehicle and contact",
    quickReview: "Your request so far",
    next: "Continue", back: "Back", edit: "Edit",
    submit: "REQUEST ROADSIDE ASSISTANCE", submitting: "Sending request…",
    fixErrors: "Please fix the highlighted fields.",
    chooseService: "What do you need help with?",
    pickup: "Where is your vehicle now?",
    useLocation: "USE MY CURRENT LOCATION",
    locating: "Finding your location…",
    locDenied: "Location permission was denied. Please type the address below — your request will still go through.",
    locUnavailable: "We couldn't get your location. Please type the address below.",
    locFound: "Location captured. Please confirm the address below and drag the pin if needed.",
    useThisAddress: "Use this address",
    nearAddress: "Closest address found:",
    coordsSaved: "GPS coordinates saved",
    dragPin: "Drag the pin or tap the map to correct the spot.",
    street: "Street address or highway location",
    streetPh: "e.g. 1200 Main St or I-45 N near exit 52",
    city: "City", state: "State", zip: "ZIP code",
    pickupNotes: "Additional location instructions",
    pickupNotesPh: "Highway & exit, shoulder side, landmark, garage level, apartment or lot, gate code…",
    destination: "Where should we take the vehicle?",
    destHelp: "I need help choosing a destination",
    destOptional: "Add a destination (optional)",
    destNotes: "Destination notes",
    destNotesPh: "Shop name, drop-off instructions, business hours…",
    routeSummary: "Pickup → Destination",
    destHelpChosen: "We'll help you choose a destination",
    noDestination: "No towing destination (service on site)",
    suggestions: "Address suggestions",
    vehicleTitle: "Tell us about the vehicle",
    year: "Year", make: "Make", model: "Model", color: "Color", type: "Vehicle type",
    selectYear: "Select year", selectColor: "Select color",
    safeQ: "Is the vehicle in a safe location?",
    yes: "Yes", no: "No",
    unsafeTitle: "Your safety comes first",
    unsafeText: "If possible, move yourself and passengers to a safe place away from traffic. Turn on hazard lights. If anyone is injured or you are in danger, call 911 now.",
    call911: "Call 911",
    special: "Special access or towing requirements",
    specialPh: "e.g. AWD, low clearance, no keys, wheels won't roll, lifted truck…",
    problem: "Describe the problem",
    problemPh: "What happened? Any warning lights or noises?",
    photo: "Vehicle photo (optional)",
    photoHint: "JPG, PNG or WEBP, up to 8 MB. Up to 3 photos.",
    addPhoto: "Add photo", uploading: "Uploading…", removePhoto: "Remove photo",
    contactTitle: "How can we reach you?",
    name: "Full name", phone: "Mobile phone number", phonePh: "(713) 000-0000",
    method: "Preferred contact method", call: "Phone call", text: "Text message",
    email: "Email address (optional)", contactNotes: "Instructions for contacting you (optional)",
    contactNotesPh: "e.g. Battery low, please text first",
    consent: "I agree to be contacted by phone call or text message about this service request. Message and data rates may apply. This is not a marketing subscription.",
    privacyNote: "We use your information only to handle this request. Read our",
    privacyLink: "Privacy Policy",
    reviewTitle: "Review your request",
    reviewNote: "Check everything before you send. You can edit any section.",
    service: "Service", pickupLabel: "Pickup", destLabel: "Destination", vehicleLabel: "Vehicle",
    contactLabel: "Contact", notesLabel: "Notes", photos: "Photos",
    safe: "Safe location", unsafe: "NOT in a safe location",
    savedDraft: "Your progress is saved on this device.",
  },
  v: {
    required: "This field is required.",
    service: "Please choose a service.",
    zip: "Enter a valid 5-digit ZIP code.",
    phone: "Enter a valid 10-digit US mobile number.",
    email: "Enter a valid email address.",
    name: "Enter your full name.",
    safe: "Please answer this question.",
    consent: "Please agree so we can contact you about this request.",
    dest: "Enter a destination or choose 'I need help choosing a destination'.",
    photoType: "Only JPG, PNG or WEBP photos are allowed.",
    photoSize: "Photo is too large (max 8 MB).",
    street: "Enter a street address or highway location.",
  },
  vehicleTypes: { sedan: "Sedan", suv: "SUV", pickup: "Pickup Truck", van: "Van", motorcycle: "Motorcycle", other: "Other" },
  colors: { black: "Black", white: "White", silver: "Silver", gray: "Gray", red: "Red", blue: "Blue", green: "Green", brown: "Brown", gold: "Gold", other: "Other" },
  confirm: {
    title: "Request received",
    refLabel: "Your request reference number",
    awaiting: "Awaiting business confirmation",
    body: "We have received your request. It is not yet accepted or dispatched. We will contact you by {method} to confirm the service, price and arrival time.",
    duplicate: "This request was already submitted — here is your existing reference number.",
    keepRef: "Keep this number handy when we contact you.",
    callUs: "Want to talk now? Call us.",
    safety: "If you are in danger, call 911.",
    newRequest: "Start a new request",
    summary: "Request summary",
  },
  footer: {
    rights: "All rights reserved.",
    about: "Towing and roadside assistance in Houston, Texas. Request help online any time.",
    contact: "Contact",
    phoneSoon: "Phone line coming soon",
  },
  common: { loading: "Loading…", error: "Something went wrong. Please try again.", notFound: "Page not found", goHome: "Go home" },
};

const es = {
  nav: {
    services: "Servicios", how: "Cómo Funciona", area: "Área de Servicio", request: "Pedir Ayuda", menu: "Menú",
    home: "Inicio", privacy: "Privacidad", terms: "Términos", skip: "Saltar al contenido principal", admin: "Acceso del propietario",
  },
  cta: {
    getHelp: "OBTENER AYUDA AHORA", callNow: "LLAMAR AHORA", textUs: "ENVIAR TEXTO", requestHelp: "Pedir Ayuda",
    requestService: "SOLICITAR ESTE SERVICIO", phoneSoon: "Línea telefónica próximamente — solicite ayuda en línea",
    callShort: "Llamar",
  },
  hero: {
    eyebrow: "Houston, Texas · Grúas y Asistencia",
    title: "¿Varado? Vamos en Camino.",
    sub247: "Servicio de Grúa y Asistencia en Carretera 24/7 en Houston, Texas.",
    sub: "Servicio de Grúa y Asistencia en Carretera en Houston, Texas.",
    note: "Envíe su ubicación en menos de 2 minutos. Le contactaremos para confirmar el servicio, el precio y el tiempo de llegada.",
    imageAlt: "Grúa de plataforma negra cargando un auto en el acotamiento de una autopista de Houston de noche",
  },
  sections: {
    servicesTitle: "Servicios en Carretera",
    servicesSub: "Elija lo que necesita. El formulario se abre con ese servicio ya seleccionado.",
    howTitle: "Cómo funciona",
    how: [
      ["Envíe su solicitud", "Elija un servicio, comparta su ubicación y los datos del vehículo."],
      ["Le contactamos", "Le llamamos o enviamos un texto para confirmar el trabajo y el precio."],
      ["Despacho confirmado", "Cuando usted aprueba, le avisamos cuando se asigna un conductor."],
      ["De vuelta al camino", "Atendemos su vehículo en el lugar o lo remolcamos a donde necesite."],
    ],
    areaTitle: "Área de servicio",
    areaSub: "Nuestro punto de partida es {area}. ¿No sabe si cubrimos su zona? Envíe una solicitud y le confirmamos.",
    zips: "Códigos postales atendidos",
    hours: "Horario",
    safetyTitle: "La seguridad primero",
    safetyText: "Si está en peligro o hay heridos, llame primero al 911. Si puede, muévase a un lugar seguro lejos del tráfico y encienda las luces intermitentes.",
    pricingTitle: "Precios",
    serviceCall: "Cargo por servicio",
    perMile: "Por milla",
    from: "Desde",
    customQuote: "El precio final se confirma con usted antes de comenzar cualquier trabajo.",
    ctaTitle: "¿Necesita ayuda ahora?",
    ctaSub: "Envíe su solicitud en línea — toma unos dos minutos.",
  },
  services: {
    flatbed: ["Grúa de Plataforma", "Transporte en plataforma para autos, SUV, tracción integral y vehículos bajos."],
    local_tow: ["Remolque Local", "Remolque a un taller, casa o concesionario dentro del área de Houston."],
    long_distance: ["Remolque de Larga Distancia", "Remolque fuera del área local hasta el destino que usted elija."],
    accident: ["Recuperación por Accidente", "Retiro y remolque de vehículos después de un choque."],
    flat_tire: ["Cambio de Llanta Ponchada", "Cambiamos su llanta ponchada por la de repuesto en el lugar."],
    spare_tire: ["Instalación de Llanta de Repuesto", "Montamos su llanta de repuesto para que llegue a una llantera."],
    jump_start: ["Paso de Corriente / Batería Descargada", "Paso de corriente para una batería descargada o débil."],
    lockout: ["Apertura de Vehículo / Llaves Adentro", "Ayuda para entrar a su vehículo cuando las llaves quedaron adentro."],
    fuel: ["Entrega de Combustible", "¿Sin gasolina? Le llevamos suficiente para llegar a una estación."],
    winch: ["Rescate con Malacate / Vehículo Atascado", "Sacamos vehículos atascados en lodo, zanjas, arena o terreno blando."],
    motorcycle: ["Remolque de Motocicletas", "Remolque seguro para motocicletas y scooters."],
    transport: ["Transporte de Vehículos", "Transporte programado de vehículos que no arrancan, comprados o de proyecto."],
    other: ["Otra Asistencia en Carretera", "¿Algo más? Describa el problema y le responderemos."],
  },
  wizard: {
    title: "Solicitar asistencia en carretera",
    steps: ["Servicio", "Ubicación", "Datos y enviar"],
    stepOf: "Paso {n} de 3",
    moreVehicle: "Agregar más datos del vehículo (opcional)",
    moreContact: "Agregar correo o instrucciones de contacto (opcional)",
    finalTitle: "Su vehículo y contacto",
    quickReview: "Su solicitud hasta ahora",
    next: "Continuar", back: "Atrás", edit: "Editar",
    submit: "SOLICITAR ASISTENCIA EN CARRETERA", submitting: "Enviando solicitud…",
    fixErrors: "Por favor corrija los campos marcados.",
    chooseService: "¿Con qué necesita ayuda?",
    pickup: "¿Dónde está su vehículo ahora?",
    useLocation: "USAR MI UBICACIÓN ACTUAL",
    locating: "Buscando su ubicación…",
    locDenied: "Se negó el permiso de ubicación. Escriba la dirección abajo — su solicitud se enviará de todos modos.",
    locUnavailable: "No pudimos obtener su ubicación. Escriba la dirección abajo.",
    locFound: "Ubicación capturada. Confirme la dirección abajo y mueva el marcador si es necesario.",
    useThisAddress: "Usar esta dirección",
    nearAddress: "Dirección más cercana encontrada:",
    coordsSaved: "Coordenadas GPS guardadas",
    dragPin: "Arrastre el marcador o toque el mapa para corregir el lugar.",
    street: "Dirección o ubicación en la autopista",
    streetPh: "ej. 1200 Main St o I-45 N cerca de la salida 52",
    city: "Ciudad", state: "Estado", zip: "Código postal",
    pickupNotes: "Instrucciones adicionales de ubicación",
    pickupNotesPh: "Autopista y salida, lado del acotamiento, punto de referencia, nivel del garaje, apartamento o estacionamiento, código de portón…",
    destination: "¿A dónde llevamos el vehículo?",
    destHelp: "Necesito ayuda para elegir un destino",
    destOptional: "Agregar un destino (opcional)",
    destNotes: "Notas del destino",
    destNotesPh: "Nombre del taller, instrucciones de entrega, horario…",
    routeSummary: "Recogida → Destino",
    destHelpChosen: "Le ayudaremos a elegir un destino",
    noDestination: "Sin destino de remolque (servicio en el lugar)",
    suggestions: "Sugerencias de dirección",
    vehicleTitle: "Cuéntenos sobre el vehículo",
    year: "Año", make: "Marca", model: "Modelo", color: "Color", type: "Tipo de vehículo",
    selectYear: "Seleccione el año", selectColor: "Seleccione el color",
    safeQ: "¿El vehículo está en un lugar seguro?",
    yes: "Sí", no: "No",
    unsafeTitle: "Su seguridad es primero",
    unsafeText: "Si es posible, muévase con sus pasajeros a un lugar seguro lejos del tráfico. Encienda las luces intermitentes. Si hay heridos o está en peligro, llame al 911 ahora.",
    call911: "Llamar al 911",
    special: "Requisitos especiales de acceso o remolque",
    specialPh: "ej. Tracción integral, vehículo bajo, sin llaves, las ruedas no giran, camioneta elevada…",
    problem: "Describa el problema",
    problemPh: "¿Qué pasó? ¿Alguna luz de advertencia o ruido?",
    photo: "Foto del vehículo (opcional)",
    photoHint: "JPG, PNG o WEBP, hasta 8 MB. Hasta 3 fotos.",
    addPhoto: "Agregar foto", uploading: "Subiendo…", removePhoto: "Quitar foto",
    contactTitle: "¿Cómo podemos comunicarnos con usted?",
    name: "Nombre completo", phone: "Número de celular", phonePh: "(713) 000-0000",
    method: "Método de contacto preferido", call: "Llamada", text: "Mensaje de texto",
    email: "Correo electrónico (opcional)", contactNotes: "Instrucciones para contactarle (opcional)",
    contactNotesPh: "ej. Batería baja, envíe texto primero",
    consent: "Acepto que me contacten por llamada o mensaje de texto sobre esta solicitud de servicio. Pueden aplicar tarifas de mensajes y datos. Esto no es una suscripción de mercadeo.",
    privacyNote: "Usamos su información solo para atender esta solicitud. Lea nuestra",
    privacyLink: "Política de Privacidad",
    reviewTitle: "Revise su solicitud",
    reviewNote: "Verifique todo antes de enviar. Puede editar cualquier sección.",
    service: "Servicio", pickupLabel: "Recogida", destLabel: "Destino", vehicleLabel: "Vehículo",
    contactLabel: "Contacto", notesLabel: "Notas", photos: "Fotos",
    safe: "Lugar seguro", unsafe: "NO está en un lugar seguro",
    savedDraft: "Su progreso se guarda en este dispositivo.",
  },
  v: {
    required: "Este campo es obligatorio.",
    service: "Por favor elija un servicio.",
    zip: "Ingrese un código postal válido de 5 dígitos.",
    phone: "Ingrese un número celular válido de EE. UU. de 10 dígitos.",
    email: "Ingrese un correo electrónico válido.",
    name: "Ingrese su nombre completo.",
    safe: "Por favor responda esta pregunta.",
    consent: "Por favor acepte para que podamos contactarle sobre esta solicitud.",
    dest: "Ingrese un destino o elija 'Necesito ayuda para elegir un destino'.",
    photoType: "Solo se permiten fotos JPG, PNG o WEBP.",
    photoSize: "La foto es demasiado grande (máx. 8 MB).",
    street: "Ingrese una dirección o ubicación en la autopista.",
  },
  vehicleTypes: { sedan: "Sedán", suv: "SUV", pickup: "Camioneta Pickup", van: "Van", motorcycle: "Motocicleta", other: "Otro" },
  colors: { black: "Negro", white: "Blanco", silver: "Plateado", gray: "Gris", red: "Rojo", blue: "Azul", green: "Verde", brown: "Café", gold: "Dorado", other: "Otro" },
  confirm: {
    title: "Solicitud recibida",
    refLabel: "Su número de referencia",
    awaiting: "Pendiente de confirmación",
    body: "Hemos recibido su solicitud. Todavía no ha sido aceptada ni despachada. Le contactaremos por {method} para confirmar el servicio, el precio y el tiempo de llegada.",
    duplicate: "Esta solicitud ya fue enviada — aquí está su número de referencia existente.",
    keepRef: "Tenga este número a la mano cuando le contactemos.",
    callUs: "¿Quiere hablar ahora? Llámenos.",
    safety: "Si está en peligro, llame al 911.",
    newRequest: "Iniciar una nueva solicitud",
    summary: "Resumen de la solicitud",
  },
  footer: {
    rights: "Todos los derechos reservados.",
    about: "Servicio de grúa y asistencia en carretera en Houston, Texas. Solicite ayuda en línea en cualquier momento.",
    contact: "Contacto",
    phoneSoon: "Línea telefónica próximamente",
  },
  common: { loading: "Cargando…", error: "Algo salió mal. Inténtelo de nuevo.", notFound: "Página no encontrada", goHome: "Ir al inicio" },
};

export const STRINGS = { en, es };
